<template>
    <b-card no-body>
        <div class="alert alert-danger mb-0 mx-1 mt-1" v-if="exitAction">
            <div class="alert-body">
                <strong>{{ $safe(exitAction,'name') }}</strong> isimli personelin çıkış işlemi için <strong>{{ exitDateText }}</strong> tarihine kadar olan puantaj kaydını yapacaksınız.
            </div>
        </div>
        <b-tabs pills active-nav-item-class="nav-pill-secondary" nav-wrapper-class="px-1 pt-1" content-class="mt-1 border-top">
            <b-tab title="Ön Puantaj" active>
                <monthly-preliminary-score  ref="preliminary" 
                                            :months="months" 
                                            :type-loading="typeLoading"
                                            :branches="branches"
                                            :sbranches="sbranches"
                                            :exit-action="exitAction"
                                            :types="types"></monthly-preliminary-score>
            </b-tab>
            <b-tab title="Puantaj Kaydı">
                <monthly-create-score   ref="create" 
                                        :months="months" 
                                        :type-loading="typeLoading"
                                        :branches="branches"
                                        :sbranches="sbranches"
                                        :exit-action="exitAction"                              
                                        :types="types"></monthly-create-score>
            </b-tab>
            <b-tab v-if="canLock" title="Puantaj Kilidi">
                <monthly-score-lock :months="months"/>
            </b-tab>
            <!-- <b-tab title="Harici KYKM">
                <monthly-score-bes  :months="months"
                                    ></monthly-score-bes>
            </b-tab>
            <b-tab title="Netsis">
                <monthly-netsis-score   ref="netsis"
                                        :exit-action="exitAction" 
                                        :months="months"></monthly-netsis-score>
            </b-tab> -->
        </b-tabs>
    </b-card>
</template>

<script>
import { BCard,BTabs,BTab } from 'bootstrap-vue'
import MonthlyPreliminaryScore from './components/MonthlyPreliminaryScore.vue'
import MonthlyCreateScore from './components/MonthlyCreateScore.vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import MonthlyNetsisScore from './components/MonthlyNetsisScore.vue'
import MonthlyScoreBes from './components/MonthlyScoreBes.vue'
import CompanyApi from '@/api/company'
import { AES } from 'crypto-js'
import { enc } from 'crypto-js/core'
import moment from 'moment'
import MonthlyScoreLock from './components/MonthlyScoreLock.vue'
import auth from '@/utilities/auth'

export default {
    components:{
        MonthlyPreliminaryScore,
        MonthlyCreateScore,
        MonthlyNetsisScore,
        MonthlyScoreBes,
        MonthlyScoreLock,
        BCard,
        BTabs,
        BTab
    },
    data(){
        return{
            types:[],
            typeLoading:false,
            branches:[],
            sbranches:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            exitAction:null
        }
    },
    created(){
        const query = this.$route.query['q'] || null
        if(query){
            try{
                this.exitAction = JSON.parse(AES.decrypt(decodeURI(query),'exit').toString(enc.Utf8))
            }catch(e){
                this.$router.replace({name:'monthly-score'})
            }
        }
    },
    mounted(){
        this.getWorkingTypes()
        this.getBranches()
        this.getSBranches()
    },
    methods:{
        getWorkingTypes(){
            return new Promise(resolve=>{
                this.typeLoading = true
                EmployeeOperationsApi.Score.WorkingType().then(res=>{
                    this.typeLoading = false
                    this.types = res.data.Data
                    resolve()
                }).catch(err=>{ this.typeLoading = false })
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        exitDateConver(date){
            return 
        }
    },
    computed:{
        exitDateText(){
            return moment(this.$safe(this.exitAction,'exitDate'),'YYYY-MM-DD').format('DD.MM.YYYY')
        },
        canLock(){
            return (auth.isHR && auth.baseBranch) || auth.isAdmin
        }
    }
}
</script>

<style>

</style>